import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { UserRecommendationCompatibility } from "@/schemas/user/explore";
import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";
import { getCompatibilityTypeEmoji } from "@/utils/explore";

type Props = {
  compatibility: UserRecommendationCompatibility[];
  isLargeCard?: boolean;
};

function CompatibilityScores({
  compatibility,
  isLargeCard = false,
}: Props): React.JSX.Element {
  if (!compatibility || compatibility.length === 0) {
    return <></>;
  }

  return (
    <View
      style={[
        styles.container,
        { flexDirection: isLargeCard ? "row" : "column" },
      ]}
    >
      {compatibility
        .sort((a, b) => a.rank - b.rank)
        .map((item) => (
          <View
            key={`${item.type}-${item.rank}`}
            style={[
              styles.semiTransparentBackgroundBorder,
              {
                paddingVertical: isLargeCard ? Spacings.s2 : Spacings.s1 * 1.5,
                paddingHorizontal: isLargeCard
                  ? Spacings.s2
                  : Spacings.s1 * 1.5,
              },
            ]}
          >
            <Text style={styles.scoreText}>
              {getCompatibilityTypeEmoji(item.type)}
              {item.score}%
            </Text>
          </View>
        ))}
    </View>
  );
}

const currentTheme = themes.morning;

const styles = StyleSheet.create({
  container: {
    maxWidth: "31%",
    alignItems: "flex-end",
    columnGap: Spacings.s1,
    rowGap: Spacings.s1,
  },
  semiTransparentBackgroundBorder: {
    backgroundColor: "rgba(85, 85, 85, 0.75)",
    borderRadius: 30,
  },
  scoreText: {
    color: "#ffffff",
    fontSize: currentTheme.typography.body.size.mobile - 3,
    fontWeight: "bold",
    textAlign: "center",
  },
});

export default CompatibilityScores;
